// Domain types for client locations.
export interface ClientLocation {
  id: string;
  name: string;
  street?: string;
  street2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  country?: string;
}

export interface LocationFormValues {
  name: string;
  street: string;
  street2: string;
  city: string;
  state: string;
  postalCode: string;
  country: string;
}

export const emptyLocationForm: LocationFormValues = {
  name: "",
  street: "",
  street2: "",
  city: "",
  state: "",
  postalCode: "",
  country: "",
};
